import { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  AppCard,
  AppInput,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';
import _ from 'lodash';

export default function ModuleComsaEnvironmentalOfficeNormalEnvironmentalAspectsCard(
  props
) {
  const {
    values,
    section,
    setFieldValue,
    motive,
    environmentalAffection,
    evaluation,
    noApplyToxicity = false,
    noApplyQuantity = false,
    noApplyCorrectiveMeasures = false,
  } = props;
  const [noApplyText] = useState(
    ReactDOMServer.renderToString(
      <Translator file="module-comsaEnvironmental" name="n.a" />
    )
  );
  const [evaluationText, setEvaluationText] = useState();
  const [applicabilityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no.applicable" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="applicable" />
      ),
      value: 1,
    },
  ]);
  const [controlCapacityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="no.control.capacity"
        />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="control.capacity.100"
        />
      ),
      value: 1,
    },
  ]);
  const [toxicityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="less.50.legal.limit"
        />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="50.70.legal.limit" />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="more.70.legal.limit"
        />
      ),
      value: 2,
    },
  ]);
  const [quantityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="less.90.previous.year"
        />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="90.100.previous.year"
        />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="more.110.previous.year"
        />
      ),
      value: 2,
    },
  ]);
  const [correctiveMeasureOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="less.waste.products.substitute"
        />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="minimization.plans.set"
        />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="minimization.plans.no.set"
        />
      ),
      value: 2,
    },
  ]);
  const [reportOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no.fines.reports" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="fines.sanctions" />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="reports.protests" />
      ),
      value: 2,
    },
  ]);

  useEffect(() => {
    if (values?.applicability !== undefined && values?.applicability !== null) {
      if (values?.applicability === 1) {
        if (
          values?.controlCapacity !== undefined &&
          values?.controlCapacity !== null
        ) {
          if (values?.controlCapacity === 1) {
            if (
              (values?.toxicity !== undefined && values?.toxicity !== null) ||
              noApplyToxicity
            ) {
              if (values?.report !== undefined && values?.report !== null) {
                setFieldValue(
                  'totalScore',
                  (noApplyToxicity ? 0 : values?.toxicity + 1) +
                    (noApplyQuantity
                      ? 0
                      : values?.quantity !== undefined &&
                        values?.quantity !== null
                      ? values?.quantity + 1
                      : 0) +
                    (noApplyCorrectiveMeasures
                      ? 0
                      : values?.correctiveMeasures !== undefined &&
                        values?.correctiveMeasures !== null
                      ? values?.correctiveMeasures + 1
                      : 0) +
                    values?.report +
                    1
                );
                return;
              }
              setFieldValue(
                'totalScore',
                ReactDOMServer.renderToString(
                  <Translator
                    file="module-comsaEnvironmental"
                    name="indicate.complaints.protests"
                  />
                )
              );
              return;
            }
            setFieldValue(
              'totalScore',
              ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="indicate.toxicity"
                />
              )
            );
            return;
          }
          setFieldValue('totalScore', noApplyText);
          return;
        }

        setFieldValue(
          'totalScore',
          ReactDOMServer.renderToString(
            <Translator
              file="module-comsaEnvironmental"
              name="indicate.control.capacity"
            />
          )
        );
        return;
      }
      setFieldValue('totalScore', noApplyText);
    } else if (
      values?.totalScore?.props?.name !==
      ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="indicate.applicability"
        />
      )
    ) {
      setFieldValue(
        'totalScore',
        ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.applicability"
          />
        )
      );
    }
  }, [values, noApplyToxicity, noApplyQuantity, noApplyCorrectiveMeasures]);

  useEffect(() => {
    if (
      values?.totalScore &&
      values?.totalScore !== noApplyText &&
      !_.isNumber(values?.totalScore)
    ) {
      setEvaluationText('');
    } else if (evaluation?.[section] === undefined) {
      setEvaluationText(
        ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="no.applicable" />
        )
      );
    } else if (evaluation?.[section] === true) {
      setEvaluationText(
        ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="significant" />
        )
      );
    } else
      setEvaluationText(
        ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="not-significant" />
        )
      );
  }, [evaluation, values]);

  useEffect(() => {
    if (Number.isInteger(values?.totalScore)) {
      setFieldValue(
        'relativeTotalScore',
        values?.totalScore /
          ((noApplyToxicity ? 0 : 1) +
            (noApplyQuantity ? 0 : 1) +
            (noApplyCorrectiveMeasures ? 0 : 1) +
            1) // report
      );
    } else {
      setFieldValue('relativeTotalScore', values?.totalScore);
    }
  }, [values, noApplyToxicity, noApplyQuantity, noApplyCorrectiveMeasures]);

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="reason" />:
          </div>
          <div>
            <b>{motive}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator
              file="module-comsaEnvironmental"
              name="environmental.impact"
            />
            :
          </div>
          <div>
            <b>{environmentalAffection}</b>
          </div>
        </div>
      </div>
      <div className="input-block">
        <div className="line">
          <AppSingleSelect
            options={applicabilityOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="applicability"
              />
            )}
            value={values?.applicability}
            onChange={(opt) => setFieldValue('applicability', opt)}
            isClearable
          />
          <AppSingleSelect
            options={controlCapacityOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="control.capacity"
              />
            )}
            value={values?.controlCapacity}
            onChange={(opt) => setFieldValue('controlCapacity', opt)}
            isClearable
          />
        </div>
        <div className="line">
          {noApplyToxicity ? (
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="toxicity" />
              )}
              value={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="not.applicable"
                />
              )}
              readOnly
            />
          ) : (
            <AppSingleSelect
              options={toxicityOptions}
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="toxicity" />
              )}
              value={values?.toxicity}
              onChange={(opt) => setFieldValue('toxicity', opt)}
              isClearable
            />
          )}
          {noApplyQuantity ? (
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="quantity" />
              )}
              value={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="not.applicable"
                />
              )}
              readOnly
            />
          ) : (
            <AppSingleSelect
              options={quantityOptions}
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="quantity" />
              )}
              value={values?.quantity}
              onChange={(opt) => setFieldValue('quantity', opt)}
              isClearable
            />
          )}
        </div>
        <div className="line">
          {noApplyCorrectiveMeasures ? (
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="corrective.measures"
                />
              )}
              value={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="not.applicable"
                />
              )}
              readOnly
            />
          ) : (
            <AppSingleSelect
              options={correctiveMeasureOptions}
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="corrective.measures"
                />
              )}
              value={values?.correctiveMeasures}
              onChange={(opt) => setFieldValue('correctiveMeasures', opt)}
              isClearable
            />
          )}
          <AppSingleSelect
            options={reportOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="complaints.protests"
              />
            )}
            value={values?.report}
            onChange={(opt) => setFieldValue('report', opt)}
            isClearable
          />
        </div>
      </div>
      <div className="score-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="total.score" />:
          </div>
          <div>
            <b>
              {values?.totalScore
                ? _.isNumber(values?.totalScore)
                  ? values?.totalScore.toFixed(1)
                  : values?.totalScore
                : ' '}
            </b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="total.score" />:
          </div>
          <div>
            <b>
              {values?.relativeTotalScore
                ? _.isNumber(values?.relativeTotalScore)
                  ? values?.relativeTotalScore.toFixed(1)
                  : values?.relativeTotalScore
                : ' '}
            </b>
          </div>
        </div>
        <div className={`line mb-2${evaluationText ? '' : ' no-opacity'}`}>
          <div>
            <Translator file="module-comsaEnvironmental" name="assessment" />
          </div>
          <div>
            <b
              className={
                evaluation?.[section] === undefined
                  ? 'text-success'
                  : evaluation?.[section] === true
                  ? 'text-danger'
                  : 'text-warning'
              }
            >
              {evaluationText}
            </b>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled(AppCard)`
  .card-body {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .info-block,
  .input-block,
  .score-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0.5rem;
  }

  .info-block,
  .score-block {
    text-align: center;
    .line {
      color: ${colors.primaryLight};
      span:first-child {
        color: #000;
        width: 180px;
        display: inline-block;
      }
    }
  }
  .info-block {
    @media (min-width: 1300px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .input-block {
    .line {
      flex-wrap: wrap;

      & > * {
        margin-bottom: 5px;
      }
      @media (min-width: 1300px) {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        & > * {
          width: calc(50% - 5px);
          margin-top: 5px;
        }
      }
    }
  }
  .score-block {
    flex-direction: column;
    justify-content: center;
    .line {
      min-height: 42px;
      &.no-opacity {
        opacity: 0;
      }
    }
  }
  h3 {
    font-weight: normal;
    color: ${colors.primaryLight};
  }
  h3 {
    font-weight: normal;
    color: ${colors.primaryLight};
  }
  & > div {
    border-right: 1px solid ${colors.grey300};
  }
  h3 {
    font-size: 13px;
    color: ${colors.primary};
    margin: 0 0 6px 0;
    font-weight: bold;
  }
  h4 {
    font-size: 10px;
    color: $primary;
    text-transform: uppercase;
  }
`;
